/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ columns: NonNullable<unknown> }} Statement_Tree_Csv_Import_Missing_ColumnsInputs */

const en_statement_tree_csv_import_missing_columns = /** @type {(inputs: Statement_Tree_Csv_Import_Missing_ColumnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing was imported. Missing required column(s): ${i?.columns}.`)
};

const nl_statement_tree_csv_import_missing_columns = /** @type {(inputs: Statement_Tree_Csv_Import_Missing_ColumnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Er is niets geïmporteerd. Verplichte kolom(men) ontbreken: ${i?.columns}.`)
};

/**
* | output |
* | --- |
* | "Nothing was imported. Missing required column(s): {columns}." |
*
* @param {Statement_Tree_Csv_Import_Missing_ColumnsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_csv_import_missing_columns = /** @type {((inputs: Statement_Tree_Csv_Import_Missing_ColumnsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Csv_Import_Missing_ColumnsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_csv_import_missing_columns(inputs)
	return en_statement_tree_csv_import_missing_columns(inputs)
});